import React, { Component } from 'react';
import $ from 'jquery'

class Iframe extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {

    $("#demoSection").css({
      'padding': '54px 0 0 0'
    });

    $("#demo").css({
      'height': ($(window).height()) + 'px'
    });


    setTimeout(function () { 
      $("#mainNav").addClass("navbar-shrink"); 
      //$('#loaderlayer').remove();
    
    }, 500);


    // set el height and width etc.
  }

  render() {
    return (
      <div>
        <iframe id={this.props.id} src={this.props.src} height={this.props.height} width={this.props.width} frameBorder={this.props.frameBorder} />
      </div>
    )
  }
};


class Templater extends Component {

  constructor(props) {
    super(props);
    this.getSrc = this.getSrc.bind(this);
  }

  getSrc() {
    console.log(this.props);
    switch (this.props.template) {
      case "youtube":
        return "../examples/sample-06-youtube-video.html"
        break;
      case "freelancer":
        return "../examples/sample-07-freelancer.html"
        break;
      case "activity":
        return "../examples/sample-08-agency.html"
        break;
      case "landing":
        return "../examples/sample-09-app-landing-page.html"
        break;
      case "photography":
        return "../examples/sample-10-photography-portfolio.html"
        break;
      case "video":
        return  "../examples/sample-11-video-portfolio.html"
        break
      default:
        return "../examples/sample-11-video-portfolio.html"
        break;
    }
  }



  render() {
    return (

      <section id="demoSection">
        <Iframe id="demo" width="100%" frameBorder={0} src={this.getSrc()} />
      </section>
    );
  }
};

export default Templater